import tw, {styled} from 'twin.macro';

const FlexSpacer = styled.div((props) => [
  tw`
    flex-1
  `,
]);

export default FlexSpacer;
